import elementExists from '../core/utils/element-exists';
const KlaviyoSignup = function () {
    const elements = document.querySelectorAll('[klaviyo-sign-up-form]');
    if (elementExists(elements, true)) {
        elements.forEach(element => {
            element.addEventListener('click', submitKlaviyoForm);
        });
    }
}

const submitKlaviyoForm = function (e) {
    const button = e.target;
    const list_id= button.dataset.listId;
    const fromSource= button.dataset.fromSource;
    const company_id= button.dataset.companyId;
    const url = `https://a.klaviyo.com/client/subscriptions/?company_id=${company_id}`;

    const form = e.target.closest('form');
    const checkbox = form.querySelector('[klaviyo-form-checkbox]');
    const submit = document.createElement('button')
    submit.classList.add('d-none')
    form.appendChild(submit)

    if (checkbox && !checkbox.checked) {
        submit.click();
        return false;
    } else {
        if (!form.checkValidity()) {
            submit.click();
            return false;
        }
    }

    button.innerText = 'Submitting...';
    const inputs = form.querySelectorAll('input');
    const data = {
        email: false,
        first_name: 'false',
        last_name: 'false'
    }
    inputs.forEach(input => {
        const dataset = input.dataset;
        if (typeof (dataset.klaviyo) !== 'undefined') {
            data[dataset.klaviyo] = input.value;
        }
    });
    if (data.email) {
        let attributes =  {
            "properties": {
                "formSource": fromSource
            },
            "email": data.email
        }
        // if (data.phone) {
        //     attributes.phone_number = data.phone;
        // }
        if (data.first_name) {
            attributes.first_name = data.first_name;
        }
        if (data.last_name) {
            attributes.last_name = data.last_name;
        }

        const myHeaders = new Headers();
        myHeaders.append("content-type", "application/json");
        myHeaders.append("revision", "2024-07-15");
        myHeaders.append("Cookie", "datadome=Floq2hjJBb~vVZrv4evLuFr8wm_5dPGi4qwR93BAY_p55WM03BmjWhJ8h~aVkpSe_l4XttlG3kKKbUQToCaHZgrk~52SosOWuzt4UWff7CiYCVYnwha8ekMWi5vET0OW");
        const request = {
            "data": {
                "type": "subscription",
                "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes" : attributes
                        }
                    }
                },
                "relationships": {
                    "list": {
                        "data": {
                            "type": "list",
                            "id": list_id
                        }
                    }
                }
            }
        };
        const requestOptions = {
            method: "POST",
            body: JSON.stringify( request ),
            headers: myHeaders,
            redirect: "follow"
        };


        fetch(url, requestOptions)
            .then(response => response.text())
            .then(result => { console.log('response submitted' , result); })            
            .then((result) => submit.click() )
    }
}


export default KlaviyoSignup;